import React from "react";
import { AlertCircle, Info } from "lucide-react";

// If one tab's data is malformed, show a message in that tab instead of blanking the whole page.
export class SectionErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { error: null };
  }
  static getDerivedStateFromError(error) {
    return { error };
  }
  componentDidCatch(error) {
    console.error(`Report section "${this.props.name}" failed to render:`, error);
  }
  render() {
    if (this.state.error) {
      return (
        <div className="p-6 rounded-lg border border-red-200 bg-red-50 text-red-700 flex items-start gap-3">
          <AlertCircle className="h-5 w-5 mt-0.5 flex-shrink-0" />
          <div>
            <p className="font-medium">This section couldn't be displayed.</p>
            <p className="text-sm mt-1">{String(this.state.error?.message || this.state.error)}. Regenerating the report usually fixes this.</p>
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}

// Shown when a section has no data, so an empty tab explains itself.
export function EmptyState({ title, children }) {
  return (
    <div className="p-6 rounded-lg border border-dashed border-gray-300 bg-gray-50 text-gray-600 flex items-start gap-3">
      <Info className="h-5 w-5 mt-0.5 flex-shrink-0 text-gray-400" />
      <div>
        <p className="font-medium text-gray-700">{title}</p>
        {children && <p className="text-sm mt-1">{children}</p>}
      </div>
    </div>
  );
}

// Market-analysis values are usually "High"/"Medium"/"Low" strings, but guard against anything else.
export const levelColor = (value) => {
  const v = String(value ?? "");
  return v.includes("High") ? "text-emerald-500" : v.includes("Low") ? "text-red-500" : "text-yellow-600";
};
